<div class="sdas-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'Sdas.Title' | translate }}</span>
        </div>

        <div class="action-zone">
            <button mat-button color="accent" routerLink="/sda">
                {{ 'Sdas.ButtonSdaCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'Sdas.ColumnHeaderId'|translate}}</span>
            <mat-form-field>
              <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
              <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Sdas.ResetFilterColumn' | translate }}"
                (click)="resetColumnFilter('id')" type="button">
                <mat-icon>undo</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container> -->

                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Sdas.ColumnHeaderNumber' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="number" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Sdas.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('number')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.number }}</td>
                    </ng-container>

                    <ng-container matColumnDef="targetType">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Sdas.ColumnHeaderTargetType' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="targetType" (selectionChange)="applyFilters()" multiple>
                                        @for (targetType of targetTypes; track targetType) {
                                        <mat-option [value]="targetType">
                                            {{ 'EnumSdaTargetTypes.' + targetType | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Sdas.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('targetType'); $event.stopPropagation()">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ 'EnumSdaTargetTypes.' + element.targetType | translate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="target">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Sdas.ColumnHeaderTarget' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="target" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Sdas.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('target')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.extension ? (element.extension | extensionDisplay) : element.service ? element.service.name : '' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Sdas.ResetAllFiltersColumn' | translate }}" (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                <button mat-icon-button routerLink="/sda" [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.id, element.number)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
